exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".styles__back___1Qas8{position:absolute;width:100%;height:100%;backface-visibility:hidden;top:0;left:0;transform:rotateY(180deg);border-radius:.25rem;overflow:hidden}", ""]);

// exports
exports.locals = {
	"back": "styles__back___1Qas8"
};